import React, { useState, useEffect, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";

import { useFormik } from "formik";

import { Form, Button, Row, Col, Alert } from "react-bootstrap";

import { useSelector } from "react-redux";
import { decrypt, getPublicKey, history } from "../_helpers";
import { createCharterDocumentObj, createDocumentObj } from "./common/utils";

import { contractFieldService, contractsService } from "../_services";

import { Loader } from "../_components";

import { v4 as uuidv4 } from "uuid";

import { ValidationModal } from "../_components";

import moment from "moment";
import _ from "lodash";
import "./ContractForm.scss";
import "dayjs/locale/fr";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TextField } from "@material-ui/core";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { PDFDownloadLink, Document } from "@react-pdf/renderer";
import { ContractDocument } from "./ContractDocument";
import { contractLogsService } from "../_services/contract.logs.service";
import VesselsDrawer from "./VesselDrawer/VesselsDrawer";

export const ContractForm = ({
  template,
  onValidSubmit,
  onGenerateAsk,
  onRefreshCalled,
  createdAt,
  setContractLinkShown,
  id,
  vessels,
  setVessels,
}) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const mode = queryParameters.get("mode");
  const [initialValues, setInitialValues] = useState({});
  const [askToDownloadPDF, setAskToDownloadPDF] = useState(false);
  const { t } = useTranslation();
  const [locale, setLocale] = useState();
  const user = useSelector((state) => state.authentication.user);
  let contract = useSelector((state) => state.contracts.item);
  const lang = useSelector((state) => state.contracts.lang);
  const privateKey = useSelector((state) => state.cryptKeys.privateKey);
  const [currentPage, setCurrentPage] = useState(1);
  const [nbPages, setNbPages] = useState(1);
  const [disbaleButton, setDisabledButton] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [valid, setValid] = useState(false);
  const [isLoaderShown, setLoaderShown] = useState(false);

  const [errorsLabels, setErrorsLabels] = useState([]);
  const [errorsLabelsShown, setErrorsLabelsShown] = useState(false);
  const [clickedPDF, setClickedpdf] = useState(false);
  const [isSharedContract, setIsSharedContract] = useState(false);

  const [isModalShown, setIsModalShown] = useState(false);
  const [savedEvent, setSavedEvent] = useState(null);
  const [, setShowInput] = useState(false);
  const [checked, setChecked] = useState(false);
  const [, setVATerror] = useState(false);
  const [dateAllowed, setDateAllowed] = useState(0);
  const contractFolder = useSelector((state) => state.contractFolders.item);
  const [changedFields, setChangedFields] = useState([]);

  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiInputBase-input": {
        paddingLeft: "28px",
        fontSize: "10px",
      },
      "& .css-i4bv87-MuiSvgIcon-root": {
        fontSize: "20px !important",
        paddingRight: "4px",
      },
    },
  }));
  const classes = useStyles();

  const handleDateChange = (id, val) => {
    formik.setFieldValue(id, val);
  };

  const ClearButton = (props) => {
    const { value } = props;

    return (
      <Button
        variant="warning"
        size="xs"
        onClick={() => {
          handleDateChange(value, null);
        }}
        style={{
          width: "25px",
          height: "28px",
          padding: "5px",
          position: "absolute",
          bottom: 0,
          left: 0,
        }}
      >
        <i className="fa fa-eraser"></i>
      </Button>
    );
  };
  const [passengersNumber, setPassengersNumber] = useState(1);

  useEffect(() => {
    setLocale(lang);
  }, [lang]);

  useEffect(() => {
    clickedPDF && setAskToDownloadPDF(true);
  }, [clickedPDF]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validate: (values, props) => {
      const errors = {};
      let newErrorsLabel = [];
      let startofcontract = "";
      let endofcontract = "";

      for (const key in values) {
        const value = values[key];
        const field = template.fields.find((elem) => elem.id === key);

        if (field) {
          if (
            field.id === "a6ab5975-3dc9-475b-90da-5675834c7b96" &&
            formik.values["a6ab5975-3dc9-475b-90da-5675834c7b96"] === "" &&
            (formik.values["4881c72e-9d3e-453b-abf6-2c7cf44e5c22"] === null ||
              formik.values["4881c72e-9d3e-453b-abf6-2c7cf44e5c22"] === "" ||
              formik.values["4881c72e-9d3e-453b-abf6-2c7cf44e5c22"] === 0)
          ) {
            return;
          } else {
            if (field.label === "From (date)") {
              startofcontract = value;
            }

            if (field.label === "To (date)") {
              endofcontract = value;
            }
            if (value !== "" || value) {
              if (
                field.type === "number" &&
                field.name === "secondInstalment" &&
                value <= 0
              ) {
                errors[field.id] = t(
                  "please enter a value greater than or equal to 0",
                );
              }
              if (
                field.type === "number" &&
                field.name === "thirdInstalment" &&
                value <= 0
              ) {
                errors[field.id] = t(
                  "please enter a value greater than or equal to 0",
                );
              }
            }

            if (field.name === "paxInportNb") {
              if (Required && (!value || value === 0 || value === ""))
                errors[field.id] = t("This field is required.");
            }

            if (field.name === "itineraryPorts_arrival") {
              if (typeof value !== "string") {
                let val =
                  value["$y"] + "-" + (value["$M"] + 1) + "-" + value["$D"];
                if (
                  !moment(val).isBetween(
                    startofcontract,
                    endofcontract,
                    undefined,
                    "[]",
                  )
                )
                  errors[field.id] = t(
                    "the date is not included in the date of the contract.",
                  );
              }
            }

            if (field.name === "itineraryPorts_departure") {
              if (typeof value !== "string") {
                let val =
                  value["$y"] + "-" + (value["$M"] + 1) + "-" + value["$D"];

                if (
                  !moment(val).isBetween(
                    startofcontract,
                    endofcontract,
                    undefined,
                    "[]",
                  )
                )
                  errors[field.id] = t(
                    "the date is not included in the date of the contract.",
                  );
              }
            }

            if (
              field.dateLinkedWith &&
              field.name !== "secondInstalmentDate" &&
              field.name !== "thirdInstalmentDate"
            ) {
              if (!value || value === "") {
                if (values[field.dateLinkedWith.id]) {
                  values[key] = values[field.dateLinkedWith.id];
                } else if (
                  field.required &&
                  !field.hidden &&
                  (!value || value === 0 || value === "")
                ) {
                  errors[field.id] = t("This field is required.");
                }
              } else {
                if (
                  values[field.dateLinkedWith.id] &&
                  values[field.dateLinkedWith.id] !== value &&
                  value === ""
                ) {
                } else if (
                  values[field.dateLinkedWith.id] &&
                  dateAllowed === 0 &&
                  moment(values[field.id]).isBefore(
                    moment(values[field.dateLinkedWith.id]),
                  )
                ) {
                  setDateAllowed(dateAllowed + 1);
                  errors[field.id] = t("This date is not allowed");
                }
              }
            } else if (
              field.name === "itineraryPorts_departure" ||
              field.name === "itineraryPorts_arrival"
            ) {
              // no error
              if (!value || value === "") {
                values[key] = getMinDate(field);
              }
            } else if (
              field.required &&
              field.id !== "d9b1ec6e-f41a-4c23-a206-5a45bc2659f8" &&
              (!value || value === 0 || value === "")
            ) {
              errors[field.id] = t("This field is required.");
            }

            if (
              field.required &&
              field.requiredIfField &&
              field.name !== "stakeHolderInsuranceReference"
            ) {
              const dependingFieldValue = values[field.requiredIfField.id];

              if (
                dependingFieldValue &&
                dependingFieldValue !== "" &&
                dependingFieldValue !== 0 &&
                (!value || value === 0 || value === "")
              ) {
                errors[field.id] = t("This field is required.");
              }
            }
            if (errors[field.id]) {
              newErrorsLabel.push({ key: field.page, value: t(field.label) });
            }
          }
        }
      }
      setErrorsLabels(newErrorsLabel);

      return errors;
    },

    onSubmit: async (values) => {
      setSaving(true);
      setLoaderShown(true);
      await onValidSubmit(values, true);
      const lastLog = await contractLogsService?.fetchLatestLogByFolder(
        contractFolder?.id,
      );

      const log = {
        version: lastLog?.latest + 1,
        action: `Updating agreement`,
        author: user?.id,
        updatedFields: changedFields,
      };

      await contractLogsService?.add(contractFolder.id, log);
      onGenerateAsk();
      setLoaderShown(false);
      setSaving(false);
    },
  });

  const handleKeyPress = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };
  const handleDeleteFields = async (deleter, values) => {
    setLoaderShown(true);
    var fieldIds = deleter?.fields.map((field) => {
      return field.id;
    });

    fieldIds.push(deleter.id);
    const res = await contractFieldService.removeGroup(fieldIds);
    if (res?.data?.code === 200) {
      saveDraft(values, true);
    }
  };

  const floatKeyPress = (event) => {
    if (!/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const customHandleChange = (e) => {
    const fieldId = e.target.name;
    const field = template.fields.find((f) => f.id === fieldId);

    if (field) {
      setChangedFields([
        ...changedFields,
        { fieldName: field?.name, fieldValue: e.target.value },
      ]);
      if (
        field.name === "itineraryPorts_arrival" ||
        field.name === "itineraryPorts_departure"
      ) {
        const otherItineraryFields = template.fields.filter(
          (f) =>
            (f.name === "itineraryPorts_departure" ||
              f.name === "itineraryPorts_arrival") &&
            f.id !== fieldId,
        );

        otherItineraryFields.forEach((f) => {
          const value = formik.values[f.id];

          var minDate = getMinDate(f);

          if (f.orderInTemplate > field.orderInTemplate) {
            minDate = e.target.value;
          }

          if (
            !value ||
            value === "" ||
            moment(value).isBefore(moment(minDate))
          ) {
            formik.setFieldValue(f.id, minDate);
          }
        });
      }

      if (
        field.type === "number" &&
        field.name !== "paxInportNb" &&
        field.name !== "paxNb" &&
        field.name !== "paxWithCabinNb" &&
        field.name !== "dayPaxWithoutCabinNb" &&
        field.name !== "advanceProvisioning"
      ) {
        const value = formik.values[field.id];
        if (value && value !== 0) {
          formik.setFieldValue(field.id, parseFloat(value).toFixed(2));
        }
      }
    }
  };

  const handleChangeDateLinkedWith = (e) => {
    return formik.handleChange(e);
  };

  const customFormSubmit = (e) => {
    if (!valid && !isSharedContract) {
      e.persist();
      e.preventDefault();
      formik.setSubmitting(true);
      formik
        .validateForm()
        .then(async (errors) => {
          if (Object.keys(errors)?.length > 0) {
            setErrorsLabelsShown(true);
            setClickedpdf(false);
          } else {
            formik.handleSubmit(e);
            // if (!contract.valid) {
            await contractsService.update({
              id: contract.id,
              valid: contract.valid,
            });
            //}
            formik.setSubmitting(false);
            setClickedpdf(true);
          }
        })
        .catch((err) => {
          formik.setSubmitting(false);
          setErrorsLabelsShown(false);
        });
    } else {
      setClickedpdf(true);
    }
  };

  const reallySubmitForm = (e) => {
    e.persist();
    e.preventDefault();

    formik.setSubmitting(true);
    formik
      .validateForm()
      .then((errors) => {
        if (Object.keys(errors)?.length > 0) {
          setErrorsLabelsShown(true);
        }
        if (contractFolder?.folderType === "charter") {
          if (
            formik.values["eee57ef5-a232-458d-9101-fd94750dc20a"] ===
            "Date.now()"
          ) {
            formik.values["eee57ef5-a232-458d-9101-fd94750dc20a"] = new Date();
          }
        } else {
          if (
            formik.values["97b9f415-3cf4-400b-9c02-009e32c7c528"] ===
            "Date.now()"
          ) {
            formik.values["97b9f415-3cf4-400b-9c02-009e32c7c528"] = new Date();
          }
        }

        formik.handleSubmit(e);
        formik.setSubmitting(false);
      })
      .catch((err) => {
        formik.setSubmitting(false);
      });
  };

  useEffect(() => {
    setLoaderShown(true);
    if (privateKey && template && contract) {
      let isMounted = true;
      async function init() {
        let values = {};
        let tempNbPages = 1;
        for (let field of template.fields) {
          if (field.page > tempNbPages) {
            tempNbPages = field.page;
          }

          if (field.defaultValue) {
            if (field.defaultValue === "autogenerated") {
              values[field.id] = uuidv4();
            } else {
              values[field.id] =
                field.defaultValue === "Date.now()"
                  ? Date()
                  : field.defaultValue;
            }
          } else {
            values[field.id] = "";
          }
        }

        if (
          template?.codeName === "baseTemplate" ||
          template?.codeName === "baseTemplateDay" ||
          template?.codeName === "baseTemplateCharter"
        ) {
          // Set broker's data
          const brokerNameField = template.fields.find(
            (el) => el.name === "brokerName",
          );
          if (brokerNameField) {
            values[brokerNameField.id] = user?.company?.name;
          }

          const brokerAddrField = template.fields.find(
            (el) => el.name === "brokerAddress1" || el.name === "brokerAddress",
          );
          if (brokerAddrField) {
            values[brokerAddrField.id] = user?.company?.address1;
          }

          const brokerCompanyIdField = template.fields.find(
            (el) => el.name === "brokerCompanyId",
          );
          if (brokerCompanyIdField && values[brokerCompanyIdField.id] === "") {
            values[brokerCompanyIdField.id] = user?.company?.registrationNumber;
          }

          const brokerMybaField = template.fields.find(
            (el) => el.name === "brokerMYBAref",
          );
          if (brokerMybaField) {
            values[brokerMybaField.id] = user?.company?.MYBAid;
          }

          const brokerVatField = template.fields.find(
            (el) => el.name === "brokerVATReference",
          );
          if (brokerVatField) {
            values[brokerVatField.id] = user?.company?.VATnumber;
          }

          const brokerInsuranceField = template?.fields.find(
            (el) => el.name === "brokerInsurance",
          );
          if (brokerInsuranceField) {
            values[brokerInsuranceField.id] = user?.company?.insurance;
          }
        }

        try {
          /*         const contractFolder = await contractFoldersService.find(
          contract.contractFolder.id
        ); */

          let publicKeyToUse = getPublicKey(user, contractFolder);

          if (
            isMounted &&
            contractFolder?.owner.id !== user?.id &&
            mode !== "seen"
          ) {
            setIsSharedContract(true);
          }

          if (isMounted && mode === "seen") {
            setValid(true);
          }
          for (let fieldValue of contract.fieldValues) {
            values[fieldValue.field.id] = contractFolder?.isOwnerNew
              ? decrypt(
                  fieldValue.value,
                  contract.contractFolder.newOwnerPublicKey,
                  contract.contractFolder.newOwnerSecretKey,
                )
              : contract?.contractFolder?.sharedBrokers > 0 ||
                  contract?.contractFolder?.createdFromShared
                ? decrypt(
                    fieldValue.value,
                    contract.contractFolder.ownerPublicKey,
                    contract.contractFolder.ownerPublicKey,
                  )
                : decrypt(fieldValue.value, publicKeyToUse, privateKey);
          }

          // Replace values for sameAs fields
          for (let field of template?.fields) {
            if (field.sameAs) {
              let sameAsField = null;

              for (let c of contractFolder?.contracts) {
                sameAsField = c.fieldValues.find(
                  (fv) => fv?.field.id === field?.sameAs.id,
                );
                if (sameAsField) {
                  break;
                }
              }

              if (!sameAsField) {
                const baseTemplateDay = contractFolder.contracts.find(
                  (c) => c.template?.codeName === "baseTemplateDay",
                );

                if (baseTemplateDay) {
                  for (let c of contractFolder?.contracts) {
                    sameAsField = c.fieldValues.find(
                      (fv) => fv.field.name === field.sameAs.name,
                    );
                    if (sameAsField) {
                      break;
                    }
                  }
                }
              }
              if (sameAsField) {
                values[field.id] = contract?.contractFolder?.isOwnerNew
                  ? decrypt(
                      sameAsField.value,
                      contract.contractFolder.newOwnerPublicKey,
                      contract.contractFolder.newOwnerSecretKey,
                    )
                  : contract?.contractFolder?.sharedBrokers > 0 ||
                      contract?.contractFolder?.createdFromShared
                    ? decrypt(
                        sameAsField.value,
                        contractFolder?.owner?.publicKey,
                        contractFolder?.owner?.publicKey,
                      )
                    : decrypt(sameAsField.value, publicKeyToUse, privateKey);
              }
            }
          }
        } catch (err) {}

        if (isMounted) {
          setNbPages(tempNbPages);
          setInitialValues(values);

          setLoaderShown(false);
        }
      }

      init();
      return () => {
        isMounted = false;
      };
    }
  }, [contract, user, contractFolder, mode, privateKey, template]);

  const saveDraft = async (values, deleteAction) => {
    setSaving(true);
    setLoaderShown(true);

    return formik.validateForm().then(async (errors) => {
      await onValidSubmit(values, false, deleteAction);
      const lastLog = await contractLogsService?.fetchLatestLogByFolder(
        contractFolder?.id,
      );

      const log = {
        version: lastLog?.latest + 1,
        action: `Updating agreement`,
        author: user?.id,
        updatedFields: changedFields,
      };

      await contractLogsService?.add(contractFolder.id, log);

      setSaving(false);
      setLoaderShown(false);
      setDisabledButton(false);
    });
  };

  // Wait for the save to finish before leaving, otherwise the folder page
  // reloads stale data and the PDF can be generated from incomplete values
  const saveAndClose = async (folderUrl) => {
    await saveDraft(formik.values);
    history.push(folderUrl);
  };

  const nextPage = () => {
    if (currentPage < nbPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const displayErrorsAlert = () => {
    let alertContent = t("There are errors in the following fields") + " : ";

    let first = true;

    const result = _.groupBy(errorsLabels, "key");

    Object.keys(result).forEach(function (key, index) {
      alertContent += "\n  Page " + key + ": ";
      result[key].map((item) => {
        if (!first) {
          alertContent += " / ";
        }
        alertContent += item.value;
        first = false;
        return alertContent;
      });
    });

    return (
      <Alert
        variant="danger"
        style={{ position: "fixed", top: 0, left: 0, zIndex: 5000 }}
      >
        {alertContent}
      </Alert>
    );
  };

  const getMinDate = (field) => {
    var fieldsBefore = null;
    var previousField = null;

    // Find all previous fields
    if (field.name === "itineraryPorts_departure") {
      fieldsBefore = template.fields.filter(
        (f) =>
          f.name === "itineraryPorts_arrival" &&
          f.orderInTemplate < field.orderInTemplate,
      );
    } else if (field.name === "itineraryPorts_arrival") {
      fieldsBefore = template.fields.filter(
        (f) =>
          f.name === "itineraryPorts_departure" &&
          f.orderInTemplate < field.orderInTemplate,
      );
    }

    // Select the right one
    fieldsBefore.forEach((f) => {
      if (!previousField || previousField.orderInTemplate < f.orderInTemplate) {
        previousField = f;
      }
    });

    // If there is a previous field, update the value
    if (previousField) {
      if (formik.values[previousField.id]) {
        return formik.values[previousField.id];
      } else {
        return getMinDate(previousField);
      }
    }

    // Else, take the first embarkation date
    const fromField = template.fields.find(
      (f) => f.name === "cruiseStartDateItinerary",
    );
    if (fromField) {
      if (formik.values[fromField.id]) {
        return formik.values[fromField.id];
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getDateLinkedWithValue = (field, values) => {
    if (
      !values[field.id] ||
      values[field.id] === "" /*||
      (values[field.dateLinkedWith.id] &&
        moment(values[field.id]).isBefore(
          moment(values[field.dateLinkedWith.id])
        ))*/
    ) {
      if (
        field.dateLinkedWith.dateLinkedWith &&
        (!values[field.dateLinkedWith.id] ||
          values[field.dateLinkedWith.id] === "")
      ) {
        return values[field.dateLinkedWith.dateLinkedWith.id];
      } else {
        return values[field.dateLinkedWith.id];
      }
    }

    return values[field.id];
  };
  const showinput = (e) => {
    setChecked(true);
    formik.handleChange(e);
    setShowInput(true);
  };

  const handleChangeTVA = (e) => {
    if (parseInt(e.target.value) === 0) {
      setVATerror(false);
    } else {
      setVATerror(false);
    }
    formik.handleChange(e);
  };

  const hideinput = (e) => {
    setChecked(false);
    formik.handleChange(e);
    setShowInput(false);
  };

  const [Required, setRequired] = useState(false);
  const checkStaticCharter = (e) => {
    Required === false ? setRequired(true) : setRequired(false);
    formik.handleChange(e);
  };

  const displayField = (field) => {
    const values = formik.values;
    const errors = formik.errors;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const handleBlur = formik.handleBlur;
    const handleSubmit = formik.handleSubmit;
    const isSubmitting = formik.isSubmitting;
    const wrapperStyle = field.hidden ? { display: "none" } : {};

    return (
      <div style={wrapperStyle}>
        {field.type === "radio" && (
          <div className="mb-3">
            <Form.Label style={{ marginRight: "15px" }}>
              {t(field.label)}
              {""}
              {field.required && <span class="required-text">*</span>}
            </Form.Label>
            {field?.options.map((option, index) => (
              <React.Fragment key={index}>
                <Form.Check
                  key={index}
                  inline
                  type={field.type}
                  label={t(option)}
                  name={field.id}
                  value={option}
                  onChange={(e) => {
                    option === "Other"
                      ? showinput(e)
                      : (field.label === "Agreement currency" ||
                            field.label === "Currency") &&
                          option !== "Other"
                        ? hideinput(e)
                        : handleChange(e);
                  }}
                  checked={
                    values[field.id] === option ||
                    (option === "Other" && checked)
                  }
                  isValid={touched[field.id] && !errors[field.id]}
                  isInvalid={touched[field.id] && errors[field.id]}
                  disabled={
                    isSharedContract ||
                    valid ||
                    field.id === "4cf0b121-f24c-497d-a42a-9c4d8949f6c5" ||
                    field.id === "d7b29ac8-7b37-463d-aaab-0128de8cb571" ||
                    field.id === "8b1d6361-2ffd-4977-aaff-683278a38700"
                  }
                />

                {errors[field.id] && touched[field.id] && (
                  <Form.Control.Feedback type="invalid">
                    {errors[field.id]}
                  </Form.Control.Feedback>
                )}
              </React.Fragment>
            ))}
          </div>
        )}

        {field.type === "checkbox" && (
          <div className="mb-3">
            <>
              <Form.Check
                inline
                type={field.type}
                label={t(field.label)}
                name={field.id}
                value={
                  values[field.id] === "true" || values[field.id] === true
                    ? true
                    : false
                }
                onChange={
                  field.name === "staticCharter"
                    ? checkStaticCharter
                    : handleChange
                }
                onBlur={handleBlur}
                checked={
                  values[field.id] === "true" || values[field.id] === true
                    ? true
                    : false
                }
                isValid={touched[field.id] && !errors[field.id]}
                isInvalid={touched[field.id] && errors[field.id]}
                disabled={isSharedContract || valid}
              />

              {errors[field.id] && touched[field.id] && (
                <Form.Control.Feedback type="invalid">
                  {errors[field.id]}
                </Form.Control.Feedback>
              )}
            </>
          </div>
        )}

        {field.type === "textarea" && (
          <>
            <Form.Label>
              {t(field.label)}{" "}
              {field.required && <span class="required-text">*</span>}
            </Form.Label>

            <Form.Control
              as="textarea"
              maxLength={
                field.id === "49fea0bc-a0a1-408a-986f-e33cd9a95ee5" && 750
              }
              rows={
                field.name === "specialConditions" || field.name === "annexeA"
                  ? 50
                  : 10
              }
              placeholder={
                field.name === "specialConditions"
                  ? `Most frequent particular clauses\n
- Sanitary/COVID\n
- Visas\n
- Children\n
- Diving\n
- Pets\n
- Insurance\n
- Pre/post delivery fees\n
- Jurisdiction / applicable law\n
- Static charter: commercial operation authorization/shooting\n
- Limitation of time “en route” per 24 hours period`
                  : ""
              }
              onChange={handleChange}
              onBlur={handleBlur}
              value={values[field.id]}
              isValid={touched[field.id] && !errors[field.id]}
              isInvalid={touched[field.id] && errors[field.id]}
              disabled={field.sameAs || isSharedContract || valid}
            />
            {errors[field.id] && touched[field.id] && (
              <Form.Control.Feedback type="invalid">
                {errors[field.id]}
              </Form.Control.Feedback>
            )}
          </>
        )}

        {(field.type === "text" ||
          field.type === "time" ||
          field.type === "number") &&
          field.label !== "" && (
            <>
              {field.calculated ? (
                displayCalculatedField(
                  field,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                )
              ) : (
                <>
                  {field.label !== "Client Address 3" && (
                    <Form.Label>
                      {t(field.label)}
                      {""}
                      {field.required && field.name !== "paxInportNb" ? (
                        <span class="required-text">*</span>
                      ) : Required && field.name === "paxInportNb" ? (
                        <span class="required-text">*</span>
                      ) : (
                        <span></span>
                      )}
                      {(field.name === "itineraryPorts_arrival" ||
                        field.name === "itineraryPorts_departure" ||
                        field.name === "itineraryPorts_arrivalTime" ||
                        field.name === "itineraryPorts_departureTime") && (
                        <>
                          <Button
                            variant="warning"
                            size="xs"
                            onClick={() => {
                              if (field.type === "date") {
                                formik.setFieldValue(field.id, "jj/mm/aaaa");
                              } else {
                                formik.setFieldValue(field.id, "");
                              }
                            }}
                            style={{
                              width: "27px",
                              height: "28px",
                              padding: "5px",
                              position: "absolute",

                              bottom: 0,
                              left: 0,
                            }}
                          >
                            <i className="fa fa-eraser"></i>
                          </Button>
                        </>
                      )}
                    </Form.Label>
                  )}

                  {field.label !== "Client Address 3" && (
                    <Form.Control
                      placeholder={
                        field.name === "yachtLOADinMeters" ||
                        field.name === "ChaterYachtType"
                          ? t("valid format xx.xx")
                          : ""
                      }
                      type={field.type}
                      name={field.id}
                      onChange={(e) => {
                        field.type === "date" &&
                        field.dateLinkedWith &&
                        field.minDate
                          ? handleChangeDateLinkedWith(e)
                          : field.name === "vatRate"
                            ? handleChangeTVA(e)
                            : handleChange(e);
                      }}
                      onBlur={handleBlur}
                      maxLength={field.name.includes("Address") ? 150 : 50}
                      value={
                        /*field.name === "addendumVATRate"
                      ? parseInt(values[field.id])
                      :*/ field.type === "date" &&
                        field.dateLinkedWith &&
                        field.minDate
                          ? getDateLinkedWithValue(field, values)
                          : field.name === "itineraryPorts_arrival" ||
                              field.name === "itineraryPorts_departure"
                            ? !values[field.id] || values[field.id] === ""
                              ? getMinDate(field)
                              : values[field.id]
                            : values[field.id]
                      }
                      disabled={
                        field.id === "ddbe29b9-6236-4c8b-aafe-d3146a9a9aae" ||
                        field.id === "d23a3965-1af3-4419-a805-c44a064a1edb" ||
                        field.id === "88ccaf38-2ff0-4c5a-878b-e1a11fb11ef2" ||
                        field.id === "b540b9af-303d-4fb5-8d4b-c202b50b03b7" ||
                        field.id === "cee28b8d-4efb-4c28-86e0-3a72d9da9720" ||
                        field.id === "d5b950b8-2324-423c-a99b-2e0a30dad17a" ||
                        field.id === "106bb317-b8e3-4ace-9923-95ee807af9dd" ||
                        field.id === "fffd1237-0d7e-4a3b-a9a7-8cf1d4f61d58" ||
                        field.id === "b95da880-62f4-42dc-aa25-ae0d2acb2acb" ||
                        field.id === "03172b71-730f-49a6-a44b-6775a4fce3d5" ||
                        field.id === "4ba89a8e-bacd-4c39-8759-3d092620087c" ||
                        field.id === "1a8914c4-1648-4a8e-b310-83cdb3a52cc9" ||
                        field.id === "14effde2-5e1e-41c7-b934-ad43316ef30c" ||
                        field.id === "c9f359fb-7f92-452b-9c81-8cf32ea8e111" ||
                        field.id === "cf2bafbf-a20e-4f03-a121-25aa30a48952" ||
                        field.id === "cdf304cd-1e10-4ca4-9037-7f6112863d91" ||
                        field.id === "a3b26a2d-e010-45d2-8b57-50f00bae109d" ||
                        field.id === "45006844-88a3-437e-9542-5aee3fffb073" ||
                        field.id === "c87817af-9650-426e-a7fb-f6cdb132629d" ||
                        field.id === "31cf6cb1-38fa-4957-85ff-0b06739411fa" ||
                        field.id === "25eeb678-6bda-4e1f-ae43-6fa9585ea833" ||
                        field.id === "a187bec6-35a0-4360-8896-807e87362ccf" ||
                        field.id === "e67ea9ae-bc41-4874-b46c-3b44f7ebca6d" ||
                        field.id === "e904671a-1bba-404e-adad-b45f134ec13b" ||
                        field.id === "b900f123-e2e2-40cb-a42e-696f3b92ed4c" ||
                        field.id === "e47bcb56-84a6-4a01-90f8-93d99e8af6be" ||
                        field.id === "54f2735d-26a1-4daa-8ad8-341ef16bb5f5" ||
                        field.id === "b53fb877-341a-456f-8588-506b08f8bbe0" ||
                        field.id === "f8258c89-6534-421c-8ae0-c83b0b530150" ||
                        field.id === "20bed7e4-bb15-43fa-b423-6fb99ef85240" ||
                        field.id === "702363d1-1546-42e1-bc04-4d5b3a5a7f21" ||
                        field.id === "2c5e4f8e-efc5-465a-9af6-2fa6f68204ba" ||
                        field.id === "52c7830b-7d66-4743-b492-f3a08363aefc" ||
                        field.id === "44abe5a4-6654-4431-80a9-57f1a206598e" ||
                        field.id === "7a43c954-275e-41b8-9b2e-c40a3ca67ae4" ||
                        field.id === "5a334988-110f-46b0-9919-92f83df6ab56" ||
                        field.id === "439f1ffa-4394-4911-adda-15de1292ed5c" ||
                        field.id === "fe000409-83d3-4ed8-849f-ae7d0eccbb02" ||
                        field.id === "cea3d97a-9a79-47cb-994b-12fba36ae746" ||
                        field.id === "3c631ba5-7c0b-4c9f-a42c-86acceb3f431" ||
                        field.id === "4b65055d-b42a-4953-84a3-0bea29b81b39" ||
                        field.id === "53abd5de-7bfd-4361-8d5c-e1318c438999" ||
                        field.id === "82b42f40-4d1e-4c30-a00c-526101327a44" ||
                        field.id === "7de58e94-309b-499c-988b-8f33e25b5cd1" ||
                        field.id === "7303da73-268a-429f-862c-804724af3b43" ||
                        field.id === "34fc430a-dfec-4968-80f1-d0dde6c0ecae" ||
                        field.id === "658e775b-2286-47e7-9538-4625c8896c7e" ||
                        field.id === "07a325d0-78c3-47bb-99f7-a1b5e761b30b" ||
                        field.id === "e785e3fd-8ada-4aa7-838f-c6d4508ae5a3" ||
                        field.id === "4a84c7da-57f7-4e32-a82f-d4295d2a1f3c" ||
                        field.id === "c861db6d-8398-4062-b080-596b04fd34eb" ||
                        field.id === "711b63a4-c9ff-4ec0-b0ce-5202b1989d27" ||
                        field.id === "4da3a605-2600-4b61-b732-f4f39909392a" ||
                        field.id === "ee3f5245-c7e7-48c5-b514-0565410996ee" ||
                        field.id === "ab22c676-c070-49c0-ad67-a1a812c13a8e" ||
                        field.id === "48e38c08-3a81-42d8-87dd-7dfb9b2d2dab" ||
                        field.id === "1d2ad65e-57b6-437e-a1b1-8bec31b7cc48" ||
                        field.id === "433bf7e0-4bd3-44f9-bd99-ec41fd86bc86" ||
                        field.id === "5b52253c-95f2-4d92-9b93-4573fe9ce298" ||
                        field.id === "2bc21d9e-48dc-4d50-88e9-bd7c9b4a31b7" ||
                        field.id === "0b6b9aab-1692-4e7b-b283-2d83586ae4c7" ||
                        field.id === "5b0eaa69-6639-4ae2-9a13-a1a8386e910c" ||
                        field.id === "d2535788-414d-45dc-bd26-cf0d1b8b0deb" ||
                        field?.id === "50a9b67c-9dad-4e81-9a94-95260d22b0ca" ||
                        field?.id === "b0b340bb-0d5c-47d1-9688-2cf5b69c93e6" ||
                        field?.id === "3c9e170b-fbdd-4fb1-a94d-896711d15619" ||
                        field?.id === "be6f7fb6-0faa-476e-86a3-1d8a6dca14ba" ||
                        field?.id === "946773b7-952c-4aa5-818a-0226a44cfc9e" ||
                        field?.id === "c8c4c1c9-7c0e-4e3b-9b3a-4f0e1fd71b4e" ||
                        field?.id === "f3a6c2d8-9b41-4f7e-a2c9-7e13b4a8cf02" ||
                        (field.name !== "addendumVATRate" &&
                          (field.defaultValue === "autogenerated" ||
                            field.sameAs ||
                            isSharedContract ||
                            valid))
                      }
                      isValid={touched[field.id] && !errors[field.id]}
                      isInvalid={touched[field.id] && errors[field.id]}
                      data-name={field.name}
                      min={
                        field.type === "date" && field.minDate
                          ? field.dateLinkedWith &&
                            values[field.dateLinkedWith.id] &&
                            values[field.dateLinkedWith.id] !== ""
                            ? values[field.dateLinkedWith.id]
                            : field.name === "itineraryPorts_arrival" ||
                                field.name === "itineraryPorts_departure"
                              ? getMinDate(field)
                              : createdAt
                                ? new Date(createdAt)
                                    .toISOString()
                                    .split("T")[0]
                                : new Date().toISOString()?.split("T")[0]
                          : field.name === "vatRate"
                            ? 0
                            : field.type === "number"
                              ? 1
                              : ""
                      }
                      step={
                        field.type === "number"
                          ? field.name === "paxNb" ||
                            field.name === "advanceProvisioning" ||
                            field.name === "paxWithCabinNb" ||
                            field.name === "dayPaxWithoutCabinNb" ||
                            field.name === "paxInportNb"
                            ? "1"
                            : "0.01"
                          : null
                      }
                      onKeyPress={
                        field.type === "number"
                          ? field.name === "paxNb" ||
                            field.name === "advanceProvisioning" ||
                            field.name === "paxWithCabinNb" ||
                            field.name === "dayPaxWithoutCabinNb" ||
                            field.name === "paxInportNb"
                            ? handleKeyPress
                            : field.name === "totalHoursOfNavigation" ||
                                field.name === "vatRate" ||
                                field.name === "advanceProvisioning"
                              ? floatKeyPress
                              : null
                          : null
                      }
                    />
                  )}
                  {field.defaultValue === "autogenerated" && (
                    <Form.Text className="text-muted">
                      {t("This field has been auto-generated")}
                    </Form.Text>
                  )}
                  {errors[field.id] && touched[field.id] && (
                    <Form.Control.Feedback type="invalid">
                      {errors[field.id]}
                    </Form.Control.Feedback>
                  )}
                </>
              )}
            </>
          )}

        {field.type === "date" && (
          <>
            {field.calculated ? (
              displayCalculatedField(
                field,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              )
            ) : (
              <>
                <Form.Label>
                  {t(field.label)}
                  {}
                  {field.required && <span class="required-text">*</span>}
                  {(field.name === "itineraryPorts_arrival" ||
                    field.name === "itineraryPorts_departure" ||
                    field.name === "itineraryPorts_arrivalTime" ||
                    field.name === "itineraryPorts_departureTime") && <></>}
                </Form.Label>

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={locale}
                >
                  <DatePicker
                    className={classes.root}
                    margin="normal"
                    minDate={
                      field.type === "date" && field.minDate
                        ? field.dateLinkedWith &&
                          values[field.dateLinkedWith.id] &&
                          values[field.dateLinkedWith.id] !== ""
                          ? values[field.dateLinkedWith.id]
                          : field.name === "itineraryPorts_arrival" ||
                              field.name === "itineraryPorts_departure"
                            ? getMinDate(field)
                            : createdAt
                              ? new Date(createdAt)
                                  ?.toISOString()
                                  ?.split("T")[0]
                              : new Date().toISOString().split("T")[0]
                        : ""
                    }
                    disabled={
                      field.defaultValue === "autogenerated" ||
                      field.sameAs ||
                      isSharedContract ||
                      valid
                    }
                    components={{
                      OpenPickerIcon:
                        touched[field.id] && !errors[field.id]
                          ? DoneOutlinedIcon
                          : touched[field.id] && errors[field.id]
                            ? InfoOutlinedIcon
                            : TodayOutlinedIcon,
                    }}
                    value={
                      field.type === "date" &&
                      field.dateLinkedWith &&
                      field.minDate &&
                      field.name !== "secondInstalmentDate" &&
                      field.name !== "thirdInstalmentDate"
                        ? getDateLinkedWithValue(field, values)
                        : field.name === "itineraryPorts_arrival" ||
                            field.name === "itineraryPorts_departure"
                          ? !values[field.id] || values[field.id] === ""
                            ? getMinDate(field)
                            : values[field.id]
                          : values[field.id]
                    }
                    name={field.id}
                    onChange={(val) => handleDateChange(field.id, val)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                          startAdornment:
                            field.name === "itineraryPorts_arrival" ||
                            field.name === "itineraryPorts_departure" ||
                            field.name === "itineraryPorts_arrivalTime" ||
                            field.name === "itineraryPorts_departureTime" ? (
                              <ClearButton value={field.id} />
                            ) : null,
                          onBlur: formik.handleBlur(field.id),
                        }}
                        fullWidth
                        style={{
                          display: "block",
                          width: "100%",
                          height: "30px",

                          paddingRight: "7px",
                          fontSize: "1rem",
                          fontWeight: "400",
                          lineHeight: "1.5",
                          color:
                            field.defaultValue === "autogenerated" ||
                            field.sameAs ||
                            isSharedContract ||
                            valid
                              ? "#000"
                              : "#495057",
                          backgroundColor:
                            field.defaultValue === "autogenerated" ||
                            field.sameAs ||
                            isSharedContract ||
                            valid
                              ? "#e9ecef"
                              : "white",
                          backgroundClip: "padding-box",
                          border:
                            touched[field.id] && !errors[field.id]
                              ? "1px solid #28a745"
                              : touched[field.id] && errors[field.id]
                                ? "1px solid red"
                                : "1px solid #ced4da",

                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>

                {field.defaultValue === "autogenerated" && (
                  <Form.Text className="text-muted">
                    {t("This field has been auto-generated")}
                  </Form.Text>
                )}
                {errors[field.id] && touched[field.id] && (
                  <span
                    style={{
                      width: "100%",
                      marginTop: "0.25rem",
                      fontSize: "80%",
                      color: "#dc3545",
                    }}
                  >
                    {errors[field.id]}
                  </span>
                )}
              </>
            )}
          </>
        )}

        {field.type === "deleter" && (
          <>
            <Button
              style={{
                position: "absolute",
                left: "-35px",
                top: "45px",
              }}
              variant="danger"
              onClick={() => {
                handleDeleteFields(field, values);
              }}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </>
        )}
      </div>
    );
  };

  const calculate = (a, b, operation, values = null) => {
    const numberA = a !== "" ? Number(a) : 0;
    const numberB = b !== "" ? Number(b) : 0;

    switch (operation) {
      case "+":
        return numberA + numberB;
      case "*":
        return numberA * numberB;
      case "%":
        return numberA * (numberB / 100);
      case "|":
        const changePriceField = template.fields.find(
          (elem) => elem.name === "addendumPriceChange",
        );
        if (changePriceField) {
          const changePriceValue = values[changePriceField.id];
          if (changePriceValue && changePriceValue === "Increase of cost") {
            return numberA + numberB;
          } else if (
            changePriceValue &&
            changePriceValue === "Reduction of cost"
          ) {
            return numberA - numberB;
          }
        }

        return numberA;
      default:
        return 0;
    }
  };
  const calculateTotal = (a, b, c) => {
    const numberA = a !== "" ? Number(a) : 0;
    const numberB = b !== "" ? Number(b) : 0;
    const numberC = c !== "" ? Number(c) : 0;
    return numberA + numberB + numberC;
  };

  const displayCalculatedField = (field) => {
    const values = formik.values;
    const errors = formik.errors;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const handleBlur = formik.handleBlur;
    /*     const handleSubmit = formik.handleSubmit;
    const isSubmitting = formik.isSubmitting; */

    const splitRegex = /__[\S]*?__/g;
    const splitViewElements = field.calculatedBy.split(splitRegex);

    const idToReplaceRegex = /(?:__)([\S]*?)(?=__)/g;
    const idsToReplace = field.calculatedBy.match(idToReplaceRegex);

    const operation = splitViewElements[1];

    let fieldIds = [];

    for (let id of idsToReplace) {
      const goodId = id.substring(2);

      const fieldInTemplate = template.fields.find(
        (elem) => elem.name === goodId,
      );

      if (fieldInTemplate) {
        fieldIds.push(fieldInTemplate.id);
      }
    }

    if (
      field.name === "totalDeposit" &&
      template?.codeName === "baseTemplateCharter"
    ) {
      values[field.id] = calculateTotal(
        values[fieldIds[0]],
        values[fieldIds[1]],
        values[fieldIds[2]],
      );
    } else {
      values[field.id] = calculate(
        values[fieldIds[0]],
        values[fieldIds[1]],
        operation,
        values,
      );
    }

    return (
      <>
        <Form.Label>
          {t(field.label)}
          {""}
          {field.required && <span class="required-text">*</span>}
        </Form.Label>
        <Form.Control
          type={field.type}
          name={field.id}
          onChange={handleChange}
          onBlur={handleBlur}
          value={
            field.name === "totalPriceIncVat" ||
            field.name === "vatAmount" ||
            field.name === "addendumVatAmount" ||
            field.name.includes("totalAmountPayment") ||
            field.name.includes("addendumTotalPriceInclVat") ||
            field.name.includes("totalDeposit")
              ? parseFloat(values[field.id]).toFixed(2)
              : values[field.id]
          }
          disabled={true}
          isValid={touched[field.id] && !errors[field.id]}
          isInvalid={touched[field.id] && errors[field.id]}
          data-name={field.name}
        />
        {field.defaultValue === "autogenerated" && (
          <Form.Text className="text-muted">
            {t("This field has been auto-generated")}
          </Form.Text>
        )}
        {errors[field.id] && touched[field.id] && (
          <Form.Control.Feedback type="invalid">
            {errors[field.id]}
          </Form.Control.Feedback>
        )}
      </>
    );
  };

  const displayRepeaterField = (field, values = formik.values) => {
    const addGroup = async () => {
      setDisabledButton(true);
      setLoaderShown(true);
      let lastPage = 0;

      let currentOrderInTemplate = field.orderInTemplate;

      for (let toCopyField of field.fields) {
        let copiedFields = template.fields.filter(
          (f) => f.name === toCopyField.name,
        );

        for (let copiedField of copiedFields) {
          if (copiedField.orderInTemplate > currentOrderInTemplate) {
            currentOrderInTemplate = copiedField.orderInTemplate;
            lastPage = copiedField.page;
          }
        }
      }

      currentOrderInTemplate++;

      try {
        var addedFields = [];

        if (contract.template?.codeName === "passengers") {
          for (let i = 0; i < passengersNumber; i++) {
            const deleteField = {
              type: "deleter",
              name: "deletedField",
              label: "delete",
              template: `/contract_templates/${template.id}`,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
            };
            currentOrderInTemplate++;
            const passengerFirstNameField = {
              type: "text",
              name: "passenger_firstname",
              label: "Firstname",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const passengerSurnameField = {
              type: "text",
              name: "passenger_surname",
              label: "Surname",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const passengerNationalityField = {
              type: "text",
              name: "passenger_nationality",
              label: "Nationality",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const passengerBirthdateField = {
              type: "date",
              name: "passenger_birthdate",
              label: "Date of birth",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const passengerBirthPlaceField = {
              type: "text",
              name: "passenger_birthplace",
              label: "Place of birth",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;
            const passengerPassportField = {
              type: "text",
              name: "passenger_passport",
              label: "Passport/ID n°",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: true,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 4,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            addedFields.push(
              deleteField,
              passengerFirstNameField,
              passengerSurnameField,
              passengerNationalityField,
              passengerBirthdateField,
              passengerBirthPlaceField,
              passengerPassportField,
            );
          }
        } else if (contract.template?.codeName === "itinerary") {
          const deleteField = {
            type: "deleter",
            name: "deletedField",
            label: "delete",
            template: `/contract_templates/${template.id}`,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 12,
          };
          currentOrderInTemplate++;
          const itineraryPortsNameField = {
            type: "text",
            name: "itineraryPorts_name",
            label: "Port of call",
            template: `/contract_templates/${template.id}`,
            defaultValue: null,
            required: null,
            requiredIfValue: null,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 4,
            displayConditionField: null,
            displayConditionValue: null,
          };
          currentOrderInTemplate++;
          const itineraryPortsArrivalField = {
            type: "date",
            name: "itineraryPorts_arrival",
            label: "Date of arrival",
            template: `/contract_templates/${template.id}`,
            defaultValue: null,
            required: null,
            requiredIfValue: null,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 2,
            displayConditionField: null,
            displayConditionValue: null,
          };
          const itineraryPortsArrivalTimeField = {
            type: "time",
            name: "itineraryPorts_arrivalTime",
            label: "Time of arrival",
            template: `/contract_templates/${template.id}`,
            defaultValue: null,
            required: null,
            requiredIfValue: null,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 2,
            displayConditionField: null,
            displayConditionValue: null,
          };
          currentOrderInTemplate++;
          const itineraryPortsDepartureField = {
            type: "date",
            name: "itineraryPorts_departure",
            label: "Date of departure",
            template: `/contract_templates/${template.id}`,
            defaultValue: null,
            required: null,
            requiredIfValue: null,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 2,
            displayConditionField: null,
            displayConditionValue: null,
          };
          const itineraryPortsDepartureTimeField = {
            type: "time",
            name: "itineraryPorts_departureTime",
            label: "Time of departure",
            template: `/contract_templates/${template.id}`,
            defaultValue: null,
            required: null,
            requiredIfValue: null,
            orderInTemplate: currentOrderInTemplate,
            page: lastPage,
            displayWidth: 2,
            displayConditionField: null,
            displayConditionValue: null,
          };
          currentOrderInTemplate++;
          addedFields.push(
            deleteField,
            itineraryPortsNameField,
            itineraryPortsArrivalField,
            itineraryPortsArrivalTimeField,
            itineraryPortsDepartureField,
            itineraryPortsDepartureTimeField,
          );
        } else if (contract.template?.codeName === "rider") {
          if (currentPage === 1) {
            const deleteField = {
              type: "deleter",
              name: "deletedField",
              label: "delete",
              template: `/contract_templates/${template.id}`,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
            };
            currentOrderInTemplate++;

            const changeOfPortsContentField = {
              type: "text",
              name: "changeOfPorts_content",
              label: "Port (cancelled, replaced and/or added)",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: null,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;
            addedFields.push(deleteField, changeOfPortsContentField);
          } else if (currentPage === 2) {
            const deleteField = {
              type: "deleter",
              name: "deletedField",
              label: "delete",
              template: `/contract_templates/${template.id}`,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
            };
            currentOrderInTemplate++;

            const changeOfEmbarkationInitial = {
              type: "text",
              name: "changeOfEmbarkation_initial",
              label: "Initial embarkation of Mr/Ms",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: null,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const changeOfEmbarkationPort = {
              type: "text",
              name: "changeOfEmbarkation_port",
              label: "Port of call",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: null,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;
            const changeOfEmbarkationDisemnarlation = {
              type: "text",
              name: "changeOfEmbarkation_disembarkations",
              label: "Disembarkations",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: null,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;

            const changeOfEmbarkationEmbarkation = {
              type: "text",
              name: "changeOfEmbarkation_embarkations",
              label: "Embarkations",
              template: `/contract_templates/${template.id}`,
              defaultValue: null,
              required: null,
              requiredIfValue: null,
              orderInTemplate: currentOrderInTemplate,
              page: lastPage,
              displayWidth: 12,
              displayConditionField: null,
              displayConditionValue: null,
            };
            currentOrderInTemplate++;
            addedFields.push(
              deleteField,
              changeOfEmbarkationInitial,
              changeOfEmbarkationPort,
              changeOfEmbarkationDisemnarlation,
              changeOfEmbarkationEmbarkation,
            );
          }
        }

        await contractFieldService.addGroup(addedFields, template.id);
        saveDraft(values);
        //setLoaderShown(false);
      } catch (err) {
        console.error(err);
        setLoaderShown(false);
      }
    };

    return (
      <>
        {contract.template?.codeName === "passengers" && (
          <Form.Control
            type="number"
            value={passengersNumber}
            style={{ marginBottom: "10px" }}
            onChange={(e) => setPassengersNumber(e.target.value)}
          />
        )}

        <Button
          disabled={field.label === "Add a line" ? disbaleButton : false}
          onClick={() => {
            addGroup();
          }}
          variant="primary"
          size="sm"
        >
          {t(field.label === "Add a port" ? "Add a line" : field.label)}
        </Button>
      </>
    );
  };

  const downloadRef = useRef();

  const RenderContractPdf = () => {
    if (!contract) {
      return <></>;
    }
    const fieldValues = contract?.fieldValues.filter((fv) => !fv?.field.hidden);
    contract = {
      ...contract,
      fieldValues,
    };
    const documentObj =
      contractFolder.folderType === "charter"
        ? createCharterDocumentObj(
            contract,
            contractFolder,
            moment,
            user,
            privateKey,
            t,
          )
        : createDocumentObj(
            contract,
            contractFolder,
            moment,
            user,
            privateKey,
            t,
          );

    if (!documentObj) {
      return <></>;
    }
    return (
      <PDFDownloadLink
        className="pdf-download-link"
        document={
          <Document>
            <ContractDocument
              contract={documentObj?.contract}
              jsonView={documentObj?.jsonView}
              status={contractFolder?.status}
              user={user}
              lang={contractFolder?.lang}
              type={contractFolder?.folderType}
            />
          </Document>
        }
        fileName={documentObj.filename}
      >
        {({ blob, url, loading, error }) => (
          <Button variant="secondary" disabled={loading} ref={downloadRef}>
            {loading ? t("Loading") + "..." : t("Download the PDF")}
          </Button>
        )}
      </PDFDownloadLink>
    );
  };

  const sameAsCentralAgent = () => {
    const centralAgentField = template.fields.find(
      (f) => f.name === "centralAgent",
    );

    const stakeholderField = template.fields.find(
      (f) => f.name === "stakeholder",
    );

    if (centralAgentField && stakeholderField) {
      formik.setFieldValue(
        stakeholderField.id,
        formik.values[centralAgentField.id],
      );
    }

    const caAddrcharter = template.fields.find(
      (f) => f.name === "centralAgentAddress",
    );
    const stAddrcharter = template.fields.find(
      (f) => f.name === "stakeholderAddress",
    );

    if (caAddrcharter && stAddrcharter) {
      formik.setFieldValue(stAddrcharter.id, formik.values[caAddrcharter.id]);
    }
    const caAddr1 = template.fields.find(
      (f) => f.name === "centralAgentAddress1",
    );
    const stAddr1 = template.fields.find(
      (f) => f.name === "stakeholderAddress1",
    );

    if (caAddr1 && stAddr1) {
      formik.setFieldValue(stAddr1.id, formik.values[caAddr1.id]);
    }

    const caAddr2 = template.fields.find(
      (f) => f.name === "centralAgentAddress2",
    );
    const stAddr2 = template.fields.find(
      (f) => f.name === "stakeholderAddress2",
    );

    if (caAddr2 && stAddr2) {
      formik.setFieldValue(stAddr2.id, formik.values[caAddr2.id]);
    }

    const caCompanyId = template.fields.find(
      (f) => f.name === "centralAgentCompanyId",
    );
    const stCompanyId = template.fields.find(
      (f) => f.name === "stakeholderCompanyId",
    );

    if (caCompanyId && stCompanyId) {
      formik.setFieldValue(stCompanyId.id, formik.values[caCompanyId.id]);
    }

    const caMyba = template.fields.find(
      (f) => f.name === "centralAgentMYBARegistration",
    );
    const stMyba = template.fields.find(
      (f) => f.name === "stakeHolderMYBAregistration",
    );

    if (caMyba && stMyba) {
      formik.setFieldValue(stMyba.id, formik.values[caMyba.id]);
    }

    const caVat = template.fields.find(
      (f) => f.name === "centralAgentVATReference",
    );
    const stVat = template.fields.find(
      (f) => f.name === "stakeHolderVATreference",
    );

    if (caVat && stVat) {
      formik.setFieldValue(stVat.id, formik.values[caVat.id]);
    }

    const stInsurance = template.fields.find(
      (f) => f.name === "stakeHolderInsuranceReference",
    );

    const stGuarantee = template.fields.find(
      (f) => f.name === "stakeHolderFinancialGuarantee",
    );
    stInsurance?.id &&
      formik.setFieldValue(stInsurance?.id, user.company?.insurance);
    stGuarantee?.id &&
      formik.setFieldValue(stGuarantee?.id, user.company?.financialGuarantee);
  };
  const sameAsBroker = () => {
    const brokerField = template.fields.find((f) => f.name === "brokerName");

    const centralAgentField = template.fields.find(
      (f) => f.name === "centralAgent",
    );

    if (brokerField && centralAgentField) {
      formik.setFieldValue(centralAgentField.id, formik.values[brokerField.id]);
    }

    const bAddcharter = template.fields.find((f) => f.name === "brokerAddress");

    const cAddcharter = template.fields.find(
      (f) => f.name === "centralAgentAddress",
    );

    if (bAddcharter && cAddcharter) {
      formik.setFieldValue(cAddcharter.id, formik.values[bAddcharter.id]);
    }

    const bAddr1 = template.fields.find((f) => f.name === "brokerAddress1");
    const caAddr1 = template.fields.find(
      (f) => f.name === "centralAgentAddress1",
    );

    if (bAddr1 && caAddr1) {
      formik.setFieldValue(caAddr1.id, formik.values[bAddr1.id]);
    }

    const bCompanyId = template.fields.find(
      (f) => f.name === "brokerCompanyId",
    );
    const caCompanyId = template.fields.find(
      (f) => f.name === "centralAgentCompanyId",
    );

    if (bCompanyId && caCompanyId) {
      formik.setFieldValue(caCompanyId.id, formik.values[bCompanyId.id]);
    }

    const bMyba = template.fields.find((f) => f.name === "brokerMYBAref");
    const caMyba = template.fields.find(
      (f) => f.name === "centralAgentMYBARegistration",
    );

    if (bMyba && caMyba) {
      formik.setFieldValue(caMyba.id, formik.values[bMyba.id]);
    }

    const bVat = template.fields.find((f) => f.name === "brokerVATReference");
    const caVat = template.fields.find(
      (f) => f.name === "centralAgentVATReference",
    );

    if (bVat && caVat) {
      formik.setFieldValue(caVat.id, formik.values[bVat.id]);
    }

    const bInsurance = template.fields.find(
      (f) => f.name === "brokerInsurance",
    );
    const caInsurance = template.fields.find(
      (f) => f.name === "centralAgentInsuranceReference",
    );

    if (bInsurance && caInsurance) {
      formik.setFieldValue(caInsurance.id, formik.values[bInsurance.id]);
    }
  };

  const [showVesselsDrawer, setShowVesselsDrawer] = useState(false);
  const toggleVesselsDrawer = () => {
    setShowVesselsDrawer(!showVesselsDrawer);
  };

  const displayForm = () => {
    return (
      <Form
        onSubmit={reallySubmitForm}
        onBlur={customHandleChange}
        onChange={() => {
          setAskToDownloadPDF(false);
        }}
        className="contractEditForm"
        noValidate
      >
        <div
          className="contractForm__page-btns"
          style={{ marginTop: "15px", marginBottom: "20px" }}
        >
          <p style={{ marginBottom: "5px" }}>
            {t("You are currently editing page")} {currentPage}
          </p>

          {currentPage > 1 && (
            <Button variant="outline-primary" onClick={previousPage}>
              {contract.template?.codeName === "rider"
                ? t("Change of ports")
                : t("Previous")}
            </Button>
          )}

          {currentPage < nbPages && (
            <Button variant="outline-primary" onClick={nextPage}>
              {contract.template?.codeName === "rider"
                ? t("Embarkations/Disembarkations")
                : t("Next")}
            </Button>
          )}
        </div>

        <hr style={{ borderTop: "1px solid #cccccc" }} />

        <Row>
          {template?.fields.map((field, index) => {
            return (
              <React.Fragment key={field.id}>
                {field.page === currentPage && (
                  <>
                    {field.type === "sectionTitle" ? (
                      <Col md="12">
                        <h3>
                          {t(field.label)}
                          {user?.id !== contractFolder?.oldOwnerId &&
                            (field?.name === "vesselTitle" ||
                              field?.name === "CharterVesselTitle" ||
                              field?.name === "agreement_yacht_title") && (
                              <Button
                                style={{ marginLeft: "10px" }}
                                onClick={toggleVesselsDrawer}
                              >
                                {t("Select a vessel")}
                              </Button>
                            )}
                        </h3>
                      </Col>
                    ) : (
                      <>
                        {(!field.displayConditionField ||
                          formik.values[field.displayConditionField.id] ===
                            field.displayConditionValue) && (
                          <Col
                            lg={field.displayWidth ? field.displayWidth : "12"}
                          >
                            <Form.Group controlId={field.id} className="d-grid">
                              {field.type === "repeater"
                                ? displayRepeaterField(field)
                                : displayField(field)}
                            </Form.Group>
                          </Col>
                        )}
                      </>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}
        </Row>

        <hr style={{ borderTop: "1px solid #cccccc" }} />

        <div className="contractForm__page-btns">
          <p style={{ marginBottom: "5px" }}>
            {t("You are currently editing page")} {currentPage}
          </p>

          {currentPage > 1 && (
            <Button variant="outline-primary" onClick={previousPage}>
              {contract.template?.codeName === "rider"
                ? t("Change of ports")
                : t("Previous")}
            </Button>
          )}

          {currentPage < nbPages && (
            <Button variant="outline-primary" onClick={nextPage}>
              {contract.template?.codeName === "rider"
                ? t("Embarkations/Disembarkations")
                : t("Next")}
            </Button>
          )}
        </div>

        <hr style={{ borderTop: "1px solid #cccccc" }} />

        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
          {user?.id !== contractFolder?.oldOwnerId && (
            <Button variant="primary" type="submit" disabled={mode === "seen"}>
              {t("Check the document")}
            </Button>
          )}
          {!askToDownloadPDF ? (
            <Button
              variant="primary"
              onClick={async (e) => {
                customFormSubmit(e);
                contract.valid === false && saveDraft(formik.values);
                setAskToDownloadPDF(true);
              }}
            >
              {t("Create the PDF")}
            </Button>
          ) : (
            <RenderContractPdf />
          )}
        </div>

        {/*<Button type='submit'>{t('Save')}</Button>*/}

        {!isSharedContract && !contract.locked && (
          <div className="contractDraftSave">
            {isSaving ? (
              <p>{t("Please wait")}...</p>
            ) : (
              <p>
                <Trans>You can save as draft anytime you want</Trans>
                &nbsp;
                <div>
                  <Button
                    variant="outline-light"
                    onClick={() => saveDraft(formik.values)}
                    className="mx-1"
                  >
                    {t("Save")}
                  </Button>

                  {template?.codeName === "baseTemplateCharter" ||
                  template?.codeName === "AddendumCharter" ? (
                    <>
                      <Button
                        variant="outline-light"
                        onClick={() =>
                          saveAndClose(
                            `/charters/folders/${contract?.contractFolder?.id}`,
                          )
                        }
                        className="mx-1"
                      >
                        {t("Save and close")}
                      </Button>
                      <Link
                        to={`/charters/folders/${contract?.contractFolder?.id}`}
                      >
                        <Button variant="outline-light">{t("Close")}</Button>
                      </Link>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outline-light"
                        onClick={() =>
                          saveAndClose(
                            `/contracts/folders/${contract?.contractFolder?.id}`,
                          )
                        }
                        className="mx-1"
                      >
                        {t("Save and close")}
                      </Button>
                      <Link
                        to={`/contracts/folders/${contract?.contractFolder?.id}`}
                      >
                        <Button variant="outline-light">{t("Close")}</Button>
                      </Link>
                    </>
                  )}
                </div>
              </p>
            )}
          </div>
        )}

        {contract.locked && (
          <div className="contractDraftSave">
            <p>
              <Trans>This addendum is no longer editable.</Trans>
            </p>
          </div>
        )}
      </Form>
    );
  };

  const onModalOptionSelected = (option) => {
    setIsModalShown(false);
    if (option === "yes") {
      if (savedEvent) {
        reallySubmitForm(savedEvent);
        setSavedEvent(null);
      }
    }
  };

  return (
    <>
      <VesselsDrawer
        show={showVesselsDrawer}
        toggle={toggleVesselsDrawer}
        vessels={vessels}
        formik={formik}
        template={template?.codeName}
        setVessels={setVessels}
        folderType={contractFolder?.folderType}
        isDay={template?.codeName === "baseTemplateDay"}
        publicKey={user?.publicKey}
        privateKey={privateKey}
      />
      <Loader isShown={isLoaderShown} />

      <ValidationModal
        title={t("Warning")}
        text={
          "<p>" +
          t(
            "WARNING ! If you generate an addendum, it will no longer be editable !",
          ) +
          "</p>" +
          "<p>" +
          t("Do you wish to continue ?") +
          "</p>"
        }
        show={isModalShown}
        onOptionSelected={onModalOptionSelected}
      />

      {errorsLabels?.length > 0 && errorsLabelsShown && displayErrorsAlert()}
      {isSharedContract && (
        <Alert variant="info">
          <p>
            {t(
              "This contract has been shared to you. You can't update the data.",
            )}
          </p>
        </Alert>
      )}

      {valid && (
        <Alert variant="info">
          <p>{t("You can't edit this contract anymore.")}</p>
        </Alert>
      )}

      {formik.initialValues && displayForm()}
    </>
  );
};
